import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { choice } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
import draggable from "vuedraggable";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
let calculator = class calculator extends Vue {
  constructor() {
    super(...arguments);
    this.editSortDialogKey = Math.random();
    this.drag = false;
    this.loading = false;
    this.catalogList = [];
    this.postForm = {
      title: "请选择以下选项",
      required: 0,
      // 是否必填
      jsonConfig: {
        showIndex: true,
        addCalculatorList: [],
        scoreVerificationEnabled: false,
        scoreVerificationList: []
      }
    };
    this.optionValidator = choice.content;
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        type: "string",
        trigger: "blur"
      }],
      "jsonConfig.calculatorList": [{
        required: true,
        type: "array",
        message: "编辑计算公式"
      }],
      // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
      whetherJoinQuestionBank: [{
        required: true,
        message: "请选择是否加入题库",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      const postForm = JSON.parse(JSON.stringify(this.value));
      this.postForm = postForm;
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    console.warn("postForm", this.postForm);
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  validateQUESTIONNAIRE(rule, value, callback) {
    let index = Number(rule.field.split(".")[2]);
    console.log("validateQUESTIONNAIRE", index);
    // 检测组件没有被删除
    if (!this.computedQuestionnaireItems.some(item => {
      return item.data.id == value;
    })) {
      return callback(Error("组件已删除或不满足计算条件，请修改组件"));
    }
    if (index < this.postForm.jsonConfig.calculatorList.length - 1) {
      console.log("validateQUESTIONNAIREindex", index, this.postForm.jsonConfig.calculatorList);
      //不是最后一个组件 需要检测后面跟的必须是判定条件
      if (this.postForm.jsonConfig.calculatorList[index + 1].type != "OPERATOR") {
        return callback(Error("题目后需要设置运算符"));
      }
    }
    callback();
  }
  validateFACTORS(rule, value, callback) {
    let index = Number(rule.field.split(".")[2]);
    if (index < this.postForm.jsonConfig.calculatorList.length - 1) {
      //不是最后一个组件 需要检测后面跟的必须是判定条件
      if (this.postForm.jsonConfig.calculatorList[index + 1].type != "OPERATOR") {
        return callback(Error("系数后需要设置运算符"));
      }
    }
    callback();
  }
  validateOPERATOR(rule, value, callback) {
    let index = Number(rule.field.split(".")[2]);
    // 检测组件没有被删除
    if (index == 0 || index == this.postForm.jsonConfig.calculatorList.length - 1) {
      return callback(Error("运算符不能在第一个和最后一个"));
    }
    if (index < this.postForm.jsonConfig.calculatorList.length - 1) {
      //不是最后一个组件 需要检测后面跟的必须是判定条件
      if (this.postForm.jsonConfig.calculatorList[index + 1].type == "OPERATOR") {
        return callback(Error("运算符后不能接运算符"));
      }
    }
    callback();
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  removeOption(item, index) {
    this.postForm.jsonConfig.calculatorList.splice(index, 1);
    this.emitChange();
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get computedQuestionnaireItems() {
    return QuestionnaireEditModule.calculatorQuestionnaireItems;
  }
  get scoreVerificationRule() {
    const scoreVerificationList = this.postForm.jsonConfig.scoreVerificationList;
    return Array.isArray(scoreVerificationList) ? scoreVerificationList[0] : undefined;
  }
  // get questionnaireItems() {
  //   return QuestionnaireEditModule.calculatorQuestionnaireItems as any;
  // }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  addCalculatorList(type) {
    this.postForm.jsonConfig.calculatorList.push({
      type,
      value: ""
    });
  }
  // 开启校验时初始化唯一一条规则，关闭时保留原配置
  onScoreVerificationEnabledChange(enabled) {
    if (!Array.isArray(this.postForm.jsonConfig.scoreVerificationList)) {
      this.$set(this.postForm.jsonConfig, "scoreVerificationList", []);
    }
    if (enabled && this.postForm.jsonConfig.scoreVerificationList.length === 0) {
      this.postForm.jsonConfig.scoreVerificationList.push(this.createScoreVerificationRule());
    }
  }
  // 创建待填写的分数校验规则
  createScoreVerificationRule() {
    return {
      operate: "",
      score: null,
      verificationResult: ""
    };
  }
  // 校验分数只能填写包含 0 的非负整数
  validateScoreVerificationScore(rule, value, callback) {
    if (value === undefined || value === null) {
      return callback(Error("请输入分数"));
    }
    if (!Number.isInteger(value) || value < 0) {
      return callback(Error("请输入大于等于0的整数"));
    }
    callback();
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  validateOptions() {
    this.getFormInstance().validateField("optionsList");
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  async validate() {
    console.log("calcul validate");
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], calculator.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], calculator.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], calculator.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], calculator.prototype, "watchPostForm", null);
calculator = __decorate([Component({
  name: "calculator",
  components: {
    PicUpload,
    questionSettingTemplate,
    draggable,
    EditSortDialog
  }
})], calculator);
export default calculator;